import { Card, CardHeader, Typography, Box } from '@mui/material'
import { PieChart } from '@mui/x-charts'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'

const TaskTargetCompletionChart = () => {
  return (
    <Card elevation={0}>
      <CardHeader
        title={
          <Typography
            sx={{
              fontSize: fontSizes.size16,
              fontWeight: fontWeights[700],
            }}
          >
            Target Completion
          </Typography>
        }
        subheader={
          <Typography variant='body2' color='text.secondary'>
            Completion breakdown
          </Typography>
        }
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: 'auto',
          padding: '0 16px',
        }}
      >
        <PieChart
          series={[
            {
              data: [
                { id: 0, value: 70, label: 'Completed', color: '#4B0082' },
                { id: 1, value: 10, label: 'Not Completed', color: '#E6E6FA' },
              ],
              highlightScope: { fade: 'global', highlight: 'item' },
              faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
            },
          ]}
          slotProps={{
            legend: {
              direction: 'vertical',
              position: { vertical: 'middle', horizontal: 'end' },
            },
          }}
          width={400}
          height={200}
          margin={{ right: 200 }}
        />
      </Box>
    </Card>
  )
}

export default TaskTargetCompletionChart
